import { render } from "./InitialLoader.vue?vue&type=template&id=7acae2b2"
import script from "./InitialLoader.vue?vue&type=script&lang=js"
export * from "./InitialLoader.vue?vue&type=script&lang=js"

import "./InitialLoader.vue?vue&type=style&index=0&id=7acae2b2&lang=scss"
script.render = render

export default script